import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateExerciseEdit = {
  exerciseEdit: { data: null, loading: false, error: null },
};

export const exerciseEdit = createAsyncThunk('user/exerciseEdit', async ({ id, ...data }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/exercise/update/${id}`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerExerciseEdit = {
  [exerciseEdit.pending]: (state) => {
    state.exerciseEdit.loading = true;
  },
  [exerciseEdit.fulfilled]: (state, action) => {
    state.exerciseEdit.loading = false;
    state.exerciseEdit.data = action.payload;
    state.exerciseEdit.error = null;
  },
  [exerciseEdit.rejected]: (state, action) => {
    state.exerciseEdit.data = null;
    state.exerciseEdit.loading = false;
    state.exerciseEdit.error = action.payload;
  },
};
